import { jsx } from "react/jsx-runtime";
import { createElement } from "react";
import { renderChildren } from "./renderChildren.js";
import { RenderElementFallback } from "./RenderElementFallback.js";
import { resolveRichTextElementMetadata } from "./resolveRichTextElementMetadata.js";
import { useRichTextRenderMetadata } from "./RichTextRenderMetadataContext.js";
function ElementRenderer({ element, children, options }) {
  const metadata = useRichTextRenderMetadata();
  const elementMetadata = resolveRichTextElementMetadata(element, metadata);
  const fallback = /* @__PURE__ */ jsx(RenderElementFallback, { element, options, children });
  return options.renderElement ? createElement(options.renderElement, {
    ...elementMetadata,
    element,
    fallback,
    children,
    renderChildren,
    renderChildrenOptions: options
  }) : fallback;
}
export {
  ElementRenderer
};
//# sourceMappingURL=ElementRenderer.js.map
